import { render } from "./Exams.vue?vue&type=template&id=9d07632a&scoped=true"
import script from "./Exams.vue?vue&type=script&lang=js"
export * from "./Exams.vue?vue&type=script&lang=js"

import "./Exams.vue?vue&type=style&index=0&id=9d07632a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d07632a"]])

export default __exports__